import { create } from 'zustand';
import { SuperAdminDataListFilterState } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

const DEFAULT_PAGE_SIZE = 10;

const createDefaultFilter = (): SuperAdminDataListFilterState => ({
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
    startDate: null,
    endDate: null,
    tenantId: null,
    ownerId: null,
    apartmentId: null,
    hotelId: null,
    documentNumber: null,
    orderBy: null,
    orderDirection: 'desc',
});

type RentChargesFilterStore = {
    filter: SuperAdminDataListFilterState;
    setFilter: (filter: Partial<SuperAdminDataListFilterState>) => void;
    resetFilter: () => void;
};

export const useSuperAdminRentChargesFilter = create<RentChargesFilterStore>((set) => ({
    filter: createDefaultFilter(),
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({ filter: createDefaultFilter() });
    },
}));
